import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Nav,
  Tab,
  Button,
  Card,
  Form,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBarcode, faCreditCard } from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as PixSVG } from "../assets/pix.svg";
import { useInvoiceContext, useControlContext } from "../context";

import {
  PAY_CREDIT_CARD,
  PAY_PIX,
  PAY_BOLETO,
  PAY_PIX_VIEW,
  PAY_BOLETO_VIEW,
  PAY_CREDIT_CARD_VIEW,
} from "../helpers";

function SelectPaymentMethod(props) {
  const [activeTab, setActiveTab] = useState("");
  const { setInvoicePaymentMethod } = useInvoiceContext();

  const handleTabSelect = (tab) => {
    setActiveTab(tab);
  };

  const { enableFormThree } = useControlContext();

  const handleNext = (event, method) => {
    enableFormThree();
    event.preventDefault();
    setInvoicePaymentMethod(method);

    switch (method) {
      case PAY_PIX:
        props.handleSelect(PAY_PIX_VIEW);
        break;
      case PAY_BOLETO:
        props.handleSelect(PAY_BOLETO_VIEW);
        break;
      case PAY_CREDIT_CARD:
        props.handleSelect(PAY_CREDIT_CARD_VIEW);
        break;
      default:
        break;
    }
  };

  return (
    <Container>
      <Tab.Container activeKey={activeTab}>
        <Row>
          <Col sm={12} className="mb-2">
            <Nav variant="pills" className="flex-column">
              <Nav.Item>
                <Nav.Link
                  eventKey={PAY_PIX}
                  onClick={() => handleTabSelect(PAY_PIX)}
                  style={{
                    color: activeTab === PAY_PIX ? "#fff" : "#6c757d",
                  }}
                >
                  <PixSVG
                    style={{
                      marginRight: "10px",
                      fill: activeTab === PAY_PIX ? "#fff" : "#6c757d",
                      width: "18px",
                      height: "18px",
                    }}
                  />
                  PIX
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  eventKey={PAY_BOLETO}
                  onClick={() => handleTabSelect(PAY_BOLETO)}
                  style={{
                    color: activeTab === PAY_BOLETO ? "#fff" : "#6c757d",
                  }}
                >
                  <FontAwesomeIcon
                    icon={faBarcode}
                    color={activeTab === PAY_BOLETO ? "#fff" : "#6c757d"}
                    style={{
                      marginRight: "10px",
                    }}
                  />
                  Boleto
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  eventKey={PAY_CREDIT_CARD}
                  onClick={() => handleTabSelect(PAY_CREDIT_CARD)}
                  style={{
                    color: activeTab === PAY_CREDIT_CARD ? "#fff" : "#6c757d",
                  }}
                >
                  <FontAwesomeIcon
                    icon={faCreditCard}
                    color={activeTab === PAY_CREDIT_CARD ? "#fff" : "#6c757d"}
                    style={{
                      marginRight: "10px",
                    }}
                  />
                  Cartão de Crédito
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col sm={12}>
            <Tab.Content>
              <Tab.Pane eventKey={PAY_PIX}>
                <Card>
                  <Card.Body>
                    <Card.Title>
                      <PixSVG
                        style={{
                          marginRight: "10px",
                          fill: "#000",
                          width: "18px",
                          height: "18px",
                        }}
                      />
                      Pagamento via PIX
                    </Card.Title>

                    <Form>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Finalize o pagamento para gerar o QRCode
                        </Form.Label>
                      </Form.Group>
                      <Button
                        variant="primary"
                        type="submit"
                        className="float-end"
                        onClick={(e) => handleNext(e, PAY_PIX)}
                      >
                        Selecionar PIX
                      </Button>
                    </Form>
                  </Card.Body>
                </Card>
              </Tab.Pane>
              <Tab.Pane eventKey={PAY_CREDIT_CARD}>
                <Card>
                  <Card.Body>
                    <Card.Title>
                      <FontAwesomeIcon
                        icon={faCreditCard}
                        color="#000"
                        style={{
                          marginRight: "10px",
                        }}
                      />
                      Pagamento via cartão de crédito
                    </Card.Title>

                    <Form>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Os dados do cartão serão solicitados ao clicar em
                          Pagar
                        </Form.Label>
                      </Form.Group>
                      <Button
                        variant="primary"
                        type="submit"
                        className="float-end"
                        onClick={(e) => handleNext(e, PAY_CREDIT_CARD)}
                      >
                        Selecionar Cartão de Crédito
                      </Button>
                    </Form>
                  </Card.Body>
                </Card>
              </Tab.Pane>
              <Tab.Pane eventKey={PAY_BOLETO}>
                <Card>
                  <Card.Body>
                    <Card.Title>
                      <FontAwesomeIcon
                        icon={faBarcode}
                        color="#000"
                        style={{
                          marginRight: "10px",
                        }}
                      />
                      Pagamento via Boleto
                    </Card.Title>

                    <Form>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Finalize o pagamento para gerar o Boleto
                        </Form.Label>
                      </Form.Group>
                      <Button
                        variant="primary"
                        type="submit"
                        className="float-end"
                        onClick={(e) => handleNext(e, PAY_BOLETO)}
                      >
                        Selecionar Boleto
                      </Button>
                    </Form>
                  </Card.Body>
                </Card>
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </Container>
  );
}

export default SelectPaymentMethod;
